












import {Vue, Component, Prop, Emit, Model, Watch} from 'vue-property-decorator';

@Component({
  name: 'MyFormItem'
})
export default class MyFormItem extends Vue {
  @Prop() label: string;
  @Prop() validFunc: Function;
  @Prop() name: string;

  selfResult: any = '';
  errorText: string = '';
  get selfVal(): any {
    return this.$parent.formResult[this.name];
  }
  get isNeedCheck(): any {
    return this.$parent.validItemArr.some((item) => {
      return item === this.name
    });
  }


  // @Watch('selfVal')
  onChangeFormResult(newValue) {
    // 校验结果，并保存在form对象上，同时判断所有校验是否正确
    this.errorText = this.validFunc(newValue)
    this.selfResult = this.errorText === '';
    this.$parent.formResult[this.name + 'Result'] = this.selfResult;
    this.$parent.validForm();
  }
}
